import { Extension } from "@tiptap/core"

interface TextAlignOptions {
  types: string[]
  alignments: string[]
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    textAlign: {
      setTextAlign: (alignment: string) => ReturnType
      unsetTextAlign: () => ReturnType
    }
  }
}

export const TextAlign = Extension.create<TextAlignOptions>({
  name: "textAlign",

  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            parseHTML: element => element.getAttribute("data-text-align"),
            renderHTML: attributes =>
              attributes.textAlign
                ? {
                    "data-text-align": attributes.textAlign,
                  }
                : null,
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setTextAlign:
        (alignment: string) =>
        ({ commands }) => {
          if (!this.options.alignments.includes(alignment)) {
            return false
          }

          return this.options.types
            .map(type =>
              commands.updateAttributes(type, { textAlign: alignment }),
            )
            .every(response => response)
        },

      unsetTextAlign:
        () =>
        ({ commands }) => {
          return this.options.types
            .map(type => commands.resetAttributes(type, "textAlign"))
            .every(response => response)
        },
    }
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify"),
    }
  },
})
